import css from 'styled-jsx/css';

export default css.global`/*
 * Component: Solid Buttons
 * ------------------
 */

.cicod-btn {
  padding: 6px 24px;
  font-size: 15px;
  border-radius: 23px;
  text-align: center;
  margin: 0;
  cursor: pointer;
  border: none;
  display: inline-block;
  transition: all 200ms ease-in-out;
  text-decoration: none;
}

.cicod-btn:active,
.cicod-btn:visited,
.cicod-btn:focus {
  text-decoration: none;
}
.dropdown-menu{
  width: 14rem !important;
}

.cicod-btn-blue {
  background: #035e35;
  color: #fff !important;
  width: 100%;
  font-size: 14px;
}
.cicod-btn-blue-small {
  background: #035e35;
  color: #fff !important;
  width: 100%;
  font-size: 12px;
}
.cicod-btn-green-2 {
  background: #21714B;
  color: #fff !important;
  font-size: 14px;
  font-weight: bold;
  padding: 11px 35px;
}
.cicod-btn-blue-half {
  background: #035e35;
  color: #fff !important;
  width: 30%;
  font-size: 14px;
}
.cicod-btn-blue-qtr {
  background: #035e35;
  color: #fff !important;
  width: 18%;
  font-size: 12px;
  font-weight: 600;
  padding: 8px 3px;
}

.cicod-btn-green-mini {
  background: #035e35;
  color: #fff !important;
  font-size: 12px;
  font-weight: 600;
  padding: 8px 3px;
}

.cicod-btn-green {
  background: #035e35;
  color: #fff !important;
  font-size: 12px;
  font-weight: 600;
  
}
.cicod-btn-green-new {
  background: #2D8645;
  color: #fff !important;
  font-size: 16px;
  font-weight: 600;
  padding: 16px 32px;
  border-radius: 30px;
  
}
.cicod-btn-green-latest {
  background: #055F36;
  color: #fff !important;
  font-size: 16px;
  font-weight: 600;
  padding: 16px 32px;
  border-radius: 30px;
  
}
.cicod-btn-green-deep {
  background: #21714B;
  color: #fff !important;
  font-size: 16px;
  font-weight: 500;
  padding: 14px 2px;
  border-radius: 40px;
  width: 210px;
  
}
.cicod-btn-plain-outline {
  background: transparent;
  color: #000000 !important;
  font-size: 16px;
  font-weight: 500;
  padding: 14px 2px;
  border-radius: 40px;
  border: 2px solid #000000;
  width: 210px;
  
}

.cicod-btn-red {
  background-color: #21714b !important;
  color: #fff !important;
  margin-left: 4px;
}

.cicod-btn-warning {
  background-color: #fdb714 !important;
  color: rgb(27, 27, 27) !important;
}

.cicod-btn-info {
  background-color: #007bff !important;
  color: #fff !important;
}

.cicod-btn-default {
  background-color: #f2f2f2 !important;
  color: #7f7f7f !important;
}

.cicod-btn-white {
  background-color: #fff;
  color: #2f2e7c !important;
  border: 1px solid #2f2e7c;
}

/*
* Component: Outline Buttons
* ------------------
*/

.cicod-btn-outline {
  background-color: transparent !important;
  border: 1px solid #035e35;
  color: #035e35 !important;
  font-weight: 500;
}
.cicod-btn-outline-gray {
  background-color: transparent !important;
  border: 1px solid #E5E7EB;
  border-radius: 40px;
  padding-top:24px;
  color: #17191C !important;
  font-weight: 600;

}
.cicod-btn-outline-new {
  background-color: transparent !important;
  border: 1px solid #2D8645;
  color: #2D8645 !important;
  font-weight: 600;
  font-size: 16px;
  line-height: 20.08px;
  padding: 16px 32px;
  border-radius: 30px;

}
.cicod-btn-outline-latest {
  background-color: transparent !important;
  border: 1px solid #000000;
  color: #000000 !important;
  font-weight: 600;
  font-size: 16px;
  line-height: 20.08px;
  padding: 16px 32px;
  border-radius: 30px;

}

.red.cicod-btn-outline {
  color: #21714b !important;
  border-color: #21714b;
}

.white.cicod-btn-white {
  color: #055b1d !important;
  border: 1px solid #055b1d;
}
.cicod-btn-white-bg {
  color: #21714B;
  background-color: #fff !important;
  font-size: 16px;
  font-weight: 600;
  padding: 14px 0px !important;
  border-radius: 40px;
  width: 179.67px;
  border:1px solid #C8CACB;
  line-height: 25.3px;
  
}

/*
* Component: sizes
* ------------------
*/

.cicod-btn-sm {
  padding: 5px 12px;
}

.cicod-btn-lg {
  padding: 12px 32px;
}

/* Form Elements Toggle */

.payment-switch {
  display: flex;
  align-items: center;
}

.payment-switch span {
  margin-right: 15px;
  font-weight: 600;
}

.payment-switch span:last-child {
  margin-left: 15px;
}

.switchToggle input[type="checkbox"] {
  height: 0;
  width: 0;
  visibility: hidden;
  position: absolute;
}

.switchToggle label {
  cursor: pointer;
  text-indent: -9999px;
  width: 70px;
  max-width: 70px;
  height: 30px;
  background: #d1d1d1;
  display: block;
  border-radius: 100px;
  position: relative;
}

.switchToggle label:after {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  width: 26px;
  height: 26px;
  background: #21714b;
  border-radius: 90px;
  transition: 0.3s;
}

.switchToggle input:checked + label,
.switchToggle input:checked + input + label {
  background: #e6e6e6;
}

.switchToggle input + label:before,
.switchToggle input + input + label:before {
  content: "";
  position: absolute;
  top: 5px;
  left: 35px;
  width: 26px;
  height: 26px;
  border-radius: 90px;
  transition: 0.3s;
  text-indent: 0;
  color: #fff;
}

.switchToggle input:checked + label:before,
.switchToggle input:checked + input + label:before {
  content: "";
  position: absolute;
  top: 5px;
  left: 10px;
  width: 26px;
  height: 26px;
  border-radius: 90px;
  transition: 0.3s;
  text-indent: 0;
  color: #fff;
}

.switchToggle input:checked + label:after,
.switchToggle input:checked + input + label:after {
  left: calc(100% - 2px);
  transform: translateX(-100%);
}

.switchToggle label:active:after {
  width: 60px;
}

.toggle-switchArea {
  margin: 10px 0 10px 0;
}

/* Custom  check */

.check {
  display: block;
  position: relative;
  padding-left: 25px;
  margin-bottom: 12px;
  padding-right: 15px;
  cursor: pointer;
  font-size: 16px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */

.check input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom checkbox */

.checkmark {
  position: absolute;
  top: 3px;
  left: 0;
  height: 18px;
  width: 18px;
  background-color: #fff;
  border-color: #035e35;
  border-style: solid;
  border-width: 2px;
}

/* When the checkbox is checked, add a blue background */

.check input:checked ~ .checkmark {
  background-color: #fff;
}

.check input:checked {
  color: red !important;
}

/* Create the checkmark/indicator (hidden when not checked) */

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */

.check input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */

.check .checkmark:after {
  left: 5px;
  top: 1px;
  width: 5px;
  height: 10px;
  border: solid;
  border-color: #2d3093;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

/* custom Radio */

/* The radio */

.radio {
  display: block;
  position: relative;
  padding-left: 20px;
  margin-bottom: 12px;
  margin-right: 20px;
  cursor: pointer;
  font-size: 13px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-weight: 400;
}

/* Hide the browser's default radio button */

.radio input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom radio button */

.checkround {
  position: absolute;
  top: 1px;
  left: 0;
  height: 13px;
  width: 13px;
  background-color: #fff;
  border-color: #21714b;
  border-style: solid;
  border-width: 1px;
  border-radius: 50%;
}

/* When the radio button is checked, add a blue background */

.radio input:checked ~ .checkround {
  background-color: #fff;
}

/* Create the indicator (the dot/circle - hidden when not checked) */

.checkround:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the indicator (dot/circle) when checked */

.radio input:checked ~ .checkround:after {
  display: block;
}

/* Style the indicator (dot/circle) */

.radio .checkround:after {
  left: 1px;
  top: 1px;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #21714b;
}

.checkbox + .checkbox,
.radio + .radio {
  margin-top: 10px;
}

.checkbox,
.radio {
  position: relative;
  display: block;
  margin-top: 10px;
  margin-bottom: 10px;
}

/* End Form Elements */

.cicod-btn-outline.blue {
  color: #2f2e7c;
  border-color: #2f2e7c;
}

.cicod-btn-outline.blue:hover {
  background-color: #2f2e7c !important;
  color: #fff;
}

@media (max-width: 768px) {
  .cicod-btn-outline-gray {
    background-color: transparent !important;
    border: 1px solid #E5E7EB;
    border-radius: 40px;
    padding:18px;
    color: #17191C !important;
    font-weight: 600;
  
  }
}
`